"use client";

import { useState } from "react";

import { useGetUserQuery } from "@/api/auth/authPrivateApi";
import { isAdmin, isManager, isProctor } from "@/src/lib/auth";

export function useReviewerAccess(): { canReview: boolean } {
  const [hasToken] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return !!localStorage.getItem("access_token");
  });

  const { data: user } = useGetUserQuery(undefined, { skip: !hasToken });

  const canReview =
    hasToken && (isManager(user) || isProctor(user) || isAdmin(user));

  return { canReview };
}
